<template>
  <div>
    <b-card class="mt-2">
      <b-card-body>
        <validation-observer ref="AddServiceOrder" #default="{ invalid }">
          <b-form @submit.prevent="formSubmitted">
            <b-row>
              <b-col cols="6">
                <b-form-group label="Service Order*" label-for="textarea-default">
                  <validation-provider rules="required" #default="{ errors }" name="Template" vid="Template">
                    <b-form-select v-model="details.template" :options="template" @change="templateChanged" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="6" v-if="HasPermission(PermissionList.Inventory_Create)">
                <b-form-group label="Warehouse*" label-for="textarea-default">
                  <validation-provider rules="required" v-slot="{ errors }" name="Warehouse" vid="Warehouse">
                    <b-form-select v-model="details.warehouseId" :options="optionsWarehouse"
                      @change="validateWarehouse" />
                    <small v-if="errors.length" class="text-danger">{{
                      errors[0]
                    }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Order Name*" label-for="mc-Order-name">
                  <validation-provider rules="required|min:3|max:100" #default="{ errors }" name="Order Name"
                    vid="Order Name">
                    <b-form-input id="mc-Order-name" placeholder="Order Name" v-model="details.orderName" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Time Estimation" label-for="mc-Time-Estimation">
                  <validation-provider rules="required|min_value:0" #default="{ errors }" name="Time Estimation"
                    vid="Time Estimation">
                    <b-form-input id="mc-Time-Estimation" type="number" placeholder="Time Estimation"
                      v-model="details.timeEstimation" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Appointment Date*" label-for="appointmentDate">
                  <validation-provider name="Appointment Date" rules="required" #default="{ errors }"
                    vid="appointmentDate">
                    <b-form-datepicker id="appointmentDate" :min="new Date()"
                      v-model="details.appointmentDate"></b-form-datepicker>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Appointment Time*" label-for="appointmentTime">
                  <validation-provider name="Appointment Time" rules="required" #default="{ errors }"
                    vid="appointmentTime">
                    <b-form-timepicker id="appointmentTime" :min="new Date()" v-model="details.appointmentTime"
                      locale="en"></b-form-timepicker>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="6" class="mb-2">
                <b-form-group label="Assign Staff*" label-for="textarea-default">
                  <!-- <validation-provider :rules="{ required: true }" #default="{ errors }" name="Assign Staff"
                    vid="Assign Staff"> -->
                    <b-form-select v-model="details.assignedStaffId" :options="staffOption"
                      @change="assignStaffChanged" />
                    <!-- <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider> -->
                </b-form-group>
              </b-col>
              <b-col cols="6" class="mb-2">
                <b-form-group label="Assign Approver" label-for="textarea-default">
                  <!-- <validation-provider :rules="{ required: true }" #default="{ errors }" name="Assign Approver"
                    vid="Assign Approver"> -->
                  <b-form-select v-model="details.assignedApproverId" :options="staffOption"
                    @change="assignApproverChanged" />
                  <!-- <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider> -->
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Price" label-for="mc-Price">
                  <validation-provider rules="numeric_decimal|min_value:0" #default="{ errors }" name="Price" vid="Price">
                    <b-form-input id="mc-Price" placeholder="Price" step="0.01" type="number" v-model="details.price" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="First Name*" label-for="mc-First-name">
                  <validation-provider rules="required|min:3|max:250" #default="{ errors }" name="First Name"
                    vid="First Name">
                    <b-form-input id="mc-First-name" placeholder="First name" v-model="details.firstName" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Last Name*" label-for="mc-Last-name">
                  <validation-provider rules="required|min:3|max:250" #default="{ errors }" name="Last Name"
                    vid="Last Name">
                    <b-form-input id="mc-Last-name" placeholder="Last Name" v-model="details.lastName" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Email" label-for="mc-Email">
                  <validation-provider rules="min:0|max:250" #default="{ errors }" name="Email" vid="Email">
                    <b-form-input id="mc-Email" placeholder="Email" v-model="details.email" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="ContactNo*" label-for="mc-ContactNo">
                  <validation-provider rules="required|numeric" #default="{ errors }" name="Contact No"
                    vid="Contact No">
                    <b-form-input id="mc-ContactNo" placeholder="Contact No" v-model="details.contactNo" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Comments" label-for="mc-Comments">
                  <validation-provider rules="min:0|max:250" #default="{ errors }" name="Comments" vid="Comments">
                    <b-form-input id="mc-Comments" placeholder="Comments" v-model="details.comments" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Location" label-for="mc-Location">
                  <validation-provider rules="min:0|max:250" #default="{ errors }" name="Location" vid="Location">
                    <b-form-input id="mc-Location" placeholder="Location" v-model="details.location" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Status*" label-for="textarea-default">
                  <validation-provider :rules="{ required: true }" #default="{ errors }" name="Status" vid="Status">
                    <b-form-select v-model="details.status" :options="statusOptions" @change="StatusChanged" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
    <validation-observer ref="addProduct">
      <!-- modal Add Item-->
      <b-modal id="modal-addProduct" :hide-footer="true" ref="addProductModal" centered title="Add Product">
        <b-form @submit.prevent="handleProdSubmit">
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label for="name">Name:</label>
                <validation-provider rules="required" #default="{ errors }" name="name">
                  <b-form-input id="name" type="text" placeholder="Name" v-model="prodName" required />
                  <small v-if="errors.length" class="text-danger text-end">{{
                    errors[0]
                  }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label for="qty">Quantity:</label>
                <validation-provider rules="required|min_value:0.00001" #default="{ errors }" name="qty">
                  <b-form-input id="qty" step="0.00001" type="text" placeholder="Quantity" v-model="prodQty" required />
                  <small v-if="errors.length" class="text-danger text-end">{{
                    errors[0]
                  }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="justify-content-end">
            <!--    <b-col cols="3">
          Button Add Item 
        <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-secondary" @click="resetProductModal">
            Close
          </b-button> 
        </b-col> -->
            <b-col cols="auto">
              <!-- Button Add Item -->
              <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="primary" @click="addProduct">
                Save
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>
    </validation-observer>
    <!-- Items Section -->
    <b-card v-if="HasPermission(PermissionList.Inventory_Create)">
      <b-card-body>
        <div ref="form" class="repeater-form" :style="{ height: trHeight }">
          <b-row v-for="(item, index) in this.invoiceData.items" :key="index" ref="row" class="pb-2 align-items-center">
            <!-- Item Dropdown -->
            <b-col cols="12" sm="6" lg="5">
              <b-form-group>
                <!-- Make header visible on all screens -->
                <span class="d-inline mb-1 font-weight-bold">Item</span>
                <div v-if="optionsProduct.length === 0 || newProd"
                  class="d-flex justify-content-center align-items-center">
                  <b-spinner variant="primary"></b-spinner>
                </div>
                <div v-else>
                  <validation-provider rules="required" v-slot="{ errors }" name="Item" vid="ItemDropdown">
                    <v-select id="select-item-dropdown" v-model="item.id" :options="optionsProduct" label="itemTitle"
                      :clearable="false" :searchable="true" class="w-100" placeholder="Select Item" append-to-body
                      @input="(val) => updateItemForm(index, val)" />
                    <small v-if="errors.length" class="text-danger">
                      {{ errors[0] }}
                    </small>
                  </validation-provider>
                </div>
              </b-form-group>
            </b-col>


            <!-- Quantity Input -->
            <b-col cols="12" sm="4" lg="5" class="qty-input">
              <b-form-group>
                <span class="d-inline d-lg-inline mr-2">Quantity</span>
                <validation-provider rules="required|min_value:0.00001" v-slot="{ errors }" name="Quantity"
                  :vid="`Quantity_${index}`">
                  <div class="flex-grow-1">
                    <b-form-input v-model="item.qty" step="0.00001" type="text" class="" />
                    <small v-if="errors.length" class="text-danger">{{
                      errors[0]
                    }}</small>
                  </div>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Delete Icon -->
            <b-col cols="12" sm="2" lg="2" class="d-flex justify-content-center align-items-center">
              <b-button variant="danger" size="sm" class="d-flex align-items-center" @click="removeFromItemForm(index)">
                Remove
              </b-button>
            </b-col>

          </b-row>
        </div>
        <b-row class="align-items-center">
          <b-col md="2">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" size="sm" variant="primary" class="mr-2"
              @click="addNewItemInItemForm">
              Add Item
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-card>
      <b-card-body>
        <div>
          <div>
            <validation-observer ref="AddServiceOrderDetails" #default="{ errors }">
              <b-form ref="tasks" :style="{ height: trHeight }" class="repeater-form">
                <b-row v-for="(item, index) in items" :id="item.id" :key="item.id" ref="row">
                  <!-- Tasks -->
                  <b-col md="4">
                    <b-form-group label="Tasks" label-for="item-tasks">
                      <validation-provider rules="required|min:3|max:250" #default="{ errors }" name="Tasks"
                        :vid="`item-tasks_${index}`" ref="item-tasks_${index}">
                        <b-form-input :id="`item-tasks_${index}`" type="text" placeholder="Enter your tasks"
                          v-model="item.tasks" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <!-- Resources -->
                  <b-col md="2">
                    <b-form-group label="Resources" label-for="resources">
                      <validation-provider rules="required|min:0|max:250" #default="{ errors }" name="Resources" vid="Resources">
                        <b-form-input :id="`resources_${index}`" type="text" placeholder="Enter your resources"
                          v-model="item.resources" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <!-- Tools -->
                  <b-col md="2">
                    <b-form-group label="Tools" label-for="tools">
                      <validation-provider rules="required|min:0|max:250" #default="{ errors }" name="Tools" vid="Tools">
                        <b-form-input :id="`tools_${index}`" type="text" placeholder="Enter your tools"
                          v-model="item.tools" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <!-- Cost -->
                  <b-col lg="2" md="1">
                    <b-form-group label="Cost" label-for="price">
                      <validation-provider rules="numeric_decimal|min_value:0" #default="{ errors }" name="Price" vid="Price">
                        <b-form-input :id="`price_${index}`" type="number" placeholder="Enter your price"
                          v-model="item.price" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <!-- Remove Button -->
                  <b-col lg="2" md="3" class="mb-50">
                    <b-button v-ripple.400="'rgba(234, 84, 85, 0.15)'" variant="outline-danger" class="mt-0 mt-md-2"
                      @click="removeItem(index)">
                      <feather-icon icon="XIcon" class="mr-25" />
                      <span>Delete</span>
                    </b-button>
                  </b-col>
                  <b-col cols="12">
                    <hr />
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </div>
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="AddNew">
            <feather-icon icon="PlusIcon" class="mr-25" />
            <span>Add New</span>
          </b-button>
          <b-row>
            <b-col cols="12" style="text-align: right">
              <b-button variant="outline-primary" class="btn btn-primary" @click="formSubmitted()">Create</b-button>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BForm,
  BButton,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormCheckbox,
  BFormFile,
  BContainer,
  BCard,
  BCardText,
  BCardBody,
  BSpinner,
  BFormDatepicker,
  BFormTimepicker,
} from "bootstrap-vue";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { FormWizard, TabContent } from "vue-form-wizard";
import { mapActions, mapGetters } from "vuex";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { quillEditor } from "vue-quill-editor";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required, min, max } from "vee-validate/dist/rules";
import en from "vee-validate/dist/locale/en.json";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import { fnSortingDropdown } from "@/libs/customFn";
import {
  customLoader,
  customError,
  customSwal,
  customErrorMessage,
} from "@/libs/customFn";
import "@/libs/customValidation";
import { ref, onUnmounted } from "@vue/composition-api";
import vSelect from "vue-select";
import { HasPermission } from "@/@core/utils/validations/permissionCheck";
import { PermissionList } from "@/libs/defaultList";


extend("required", {
  ...required,
  message: en.messages.required
});

extend("min", {
  ...min,
  message: en.messages.min
});

extend("max", {
  ...max,
  message: en.messages.max
});

export default {
  components: {
    BFormSelect,
    BFormFile,
    BFormGroup,
    BForm,
    BFormTextarea,
    BFormInput,
    FormWizard,
    BContainer,
    BButton,
    BFormCheckbox,
    BCard,
    TabContent,
    BRow,
    BCol,
    ToastificationContent,
    BCardText,
    BCardBody,
    BSpinner,
    quillEditor,
    ValidationProvider,
    ValidationObserver,
    BFormDatepicker,
    BFormTimepicker,
    vSelect, required, min, max
  },
  data() {
    return {
      id: this.$route.params.id,
      template: [],
      Status: [],
      staffOption: [],
      allStaffOption: [], 
      selectedStaffIds: [],
      staffpopulate: [],
      pushStaffIds: null,
      details: {
        id: null,
        warehouseId: null,
        orderName: null,
        orderDescription: null,
        appointmentDate: null,
        appointmentTime: null,
        appointmentDateTime: null,
        timeEstimation: null,
        template: [],
        firstName: null,
        lastName: null,
        email: null,
        price: 0.0,
        contactNo: null,
        comments: null,
        location: null,
        status: null,
        assignedStaffName: null,
        assignedStaffEmail: null,
        assignedStaffId: null,
        assignedApproverName: null,
        assignedApproverEmail: null,
        assignedApproverId: null,
        selectedTemplateId: null,
        assignStaffDetails: null,
        assignApproverDetails: null,
      },
      optionsWarehouse: [],
      budget: null,
      editorOption: {
        modules: {
          toolbar: "#toolbar",
        },
      },
      defaultItem: [
        {
          tasks: null,
          resources: null,
          tools: null,
          price: 0.0,
        },
      ],
      items: [],
      nextTodoId: 1,
      statusOptions: [
        { value: "BOOKING_PENDING", text: "Booking pending" },
        { value: "BOOKING_CONFIRMED", text: "Booking confirmed" },
        { value: "SR_IN_PROGRESS", text: "Service Request in progress" },
        { value: "SR_APPROVED", text: "Service Request approved" },
      ],
      optionsProduct: [],
      item: {
        qty: 1,
      },
      // add product modal
      prodName: "",
      prodQty: null,
      newProd: false,
      //currencyList: CurrencySymbols,
      selectedCurrency: "MUR",
      currencyOptions: [],
      staffOption: [],
      selectedStaffIds: [],
      staffpopulate: [],
      pushStaffIds: null,
      exchangeRate: 1,
      barcode: null,
      loadingButton: false,
      selectedProduct: null,
      products: [],
    };
  },
  watch: {
    "ServiceTemplateObject.budget"(val) {
      if (val === "" || val === null) {
        this.ServiceTemplateObject.budget = 0;
      }
    },
    "ServiceTemplateObject.estimatedDuration"(val) {
      if (val === "" || val === null) {
        this.ServiceTemplateObject.estimatedDuration = 0;
      }
    },
  },
  methods: {
    ...mapActions("serviceModule", [
      "getServiceTemplateListAction",
      "getServiceTemplateByIDAction",
      "getStaffForTemplateListAction",
      "postServiceOrderAction",
    ]),
    ...mapActions("employeeModule", [
      "getEmployeeListAction",
      "getEmployeeByIdAction",
    ]),
    ...mapActions("productModule", [
      "getProductListAction",
      "addProductAction",
    ]),
    ...mapActions("warehouseModule", ["getWarehouseListAction"]),
    StatusChanged(selectedValue) {
      console.log("Selected status:", selectedValue);
    },
    showSuccess() {
      this.$swal({
        title: "Service Order Created!",
        text: "You have successfully Created a Service Order!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then(() => {
        this.$router.push({ name: "serviceorder-list" });
      });
    },
    validateWarehouse() {
      //No need to val;idate on create
      // const whouseId = this.details.warehouseId;
      // console.log("warehouseid", whouseId);

      // // Check if the warehouseId exists in the itemBalance object
      // const warehousedet = this.warehouse.find(wh => wh.id === whouseId);
      // console.log("warehouse", warehousedet);
      // if (warehousedet && warehousedet.itemBalance && Array.isArray(warehousedet.itemBalance)) {
      //   const count = warehousedet.itemBalance.length; // Or check for a specific object in itemBalance
      //   if (count === 0) {
      //     this.errorWarehouse();
      //     return;
      //   }
      // } else {
      //   // Handle case where warehouseId is not found or itemBalance is missing
      //   console.error("Warehouse or itemBalance data is missing.");
      //   this.errorWarehouse();
      //   return;
      // }
    },

    isOrderNameUnique(value) {
      // Assuming you have a list of existing order names
      const existingOrderNames = []; // Replace with your actual data source
      return !existingOrderNames.includes(value);
    },

    checkValidation() {
      this.$refs.provider.validate(); // Assuming your validation provider has a ref
    },

    showProcessingDialog(text = "Please wait while the data is being loaded") {
      this.processingData = this.$swal({
        title: "Processing...",
        text: text,
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });
    },
    hideProcessingDialog() {
      if (this.processingData) {
        this.processingData.close();
        this.processingData = null;
      }
    },
    async downloadFile(id, fileName) { },
    async uploadFiles(selectedFiles) { },
    async deleteFile(id) { },
    formChanged() { },
    async templateChanged(newValue) {
      try {
        
        this.showProcessingDialog("Retrieving template's sub-tasks and items");
        await this.getServiceTemplateByIDAction(newValue).then(() => {
          
          // Handle tasks population
          this.items = this.ServiceTemplateObject != null && 
            this.ServiceTemplateObject.orderTemplateDetails != null
            ? this.ServiceTemplateObject.orderTemplateDetails
            : [];

          // Handle items/products population
          if (this.ServiceTemplateObject != null && 
              this.ServiceTemplateObject.orderTemplateProducts != null &&
              this.ServiceTemplateObject.orderTemplateProducts.length > 0) {
            
            // Clear existing items
            this.invoiceData.items = [];
            
            // Map and populate products
            this.ServiceTemplateObject.orderTemplateProducts.forEach(product => {
              const mappedItem = {
                qty: product.quantity || 1,
                value: product.productId,
                id: {
                  value: product.productId,
                  itemTitle: this.getProductName(product.productId)
                },
                itemTitle: this.getProductName(product.productId)
              };
              this.invoiceData.items.push(mappedItem);
            });
            
            console.log('Final Mapped Items:', this.invoiceData.items); // Log 7: Final items array
          } else {
            console.log('No products found in template or invalid template data'); // Log 8: Missing data warning
          }

          console.log("this.ServiceTemplateObject", this.ServiceTemplateObject);

          // Set other template details
          this.details.selectedTemplateId = this.ServiceTemplateObject != null 
            ? this.ServiceTemplateObject.id 
            : 0;
          this.details.price = this.ServiceTemplateObject != null 
            ? this.ServiceTemplateObject.budget 
            : 0;
          this.details.timeEstimation = this.ServiceTemplateObject != null 
            ? this.ServiceTemplateObject.estimatedDuration 
            : 0;

            if (this.ServiceTemplateObject?.staffId) {
  
  // staffId can be "id1,id2,id3"
  const templateStaffIds = this.ServiceTemplateObject.staffId.split(",").map(s => s.trim());

  // Filter staffOption
  this.staffOption = this.allStaffOption.filter(staff =>
    templateStaffIds.includes(staff.value)
  );

  // Preselect assigned staff ID(s)
  // If multiple, pick the first one (or handle as array)
  this.details.assignedStaffId = templateStaffIds[0];

} else {
  // No staff assigned → show all staff
  this.staffOption = [...this.allStaffOption];
  this.details.assignedStaffId = null;
}

          this.initTrHeight();
        });
        this.hideProcessingDialog();
      } catch (error) {
        console.error('Error in templateChanged:', error);
        console.error('Error details:', { 
          templateId: newValue,
          serviceTemplateObject: this.ServiceTemplateObject,
          error: error.message
        });
        this.hideProcessingDialog();
      }
    },

    // Add helper method to get product name
    getProductName(productId) {
      const product = this.ProductList.find(p => p.id === productId);
      return product ? product.name : '';
    },
    // async templateChanged(newValue) {
    //   try {
    //     this.showProcessingDialog("Retrieving template's sub-tasks");
    //     await this.getServiceTemplateByIDAction(newValue).then(() => {
    //       this.items =
    //         this.ServiceTemplateObject != null &&
    //           this.ServiceTemplateObject.orderTemplateDetails != null
    //           ? this.ServiceTemplateObject.orderTemplateDetails
    //           : [];
    //       this.details.selectedTemplateId =
    //         this.ServiceTemplateObject != null
    //           ? this.ServiceTemplateObject.id
    //           : 0;
    //       this.details.price =
    //         this.ServiceTemplateObject != null
    //           ? this.ServiceTemplateObject.budget
    //           : 0;
    //       this.details.timeEstimation =
    //         this.ServiceTemplateObject != null
    //           ? this.ServiceTemplateObject.estimatedDuration
    //           : 0;
    //       this.initTrHeight();
    //     });
    //     this.hideProcessingDialog();
    //   } catch (error) {
    //     console.error("Error fetching service template list:", error);
    //   }
    // },
    async assignStaffChanged(selectedId) {
      this.details.assignStaffDetails = null;
      this.details.assignedStaffId = null;
      if (this.staffList != null) {
        let staffDetails = this.staffList.filter((v) => v.id == selectedId)[0];
        if (staffDetails != null) {
          let reqDetails = {
            assignedStaffName: `${staffDetails.firstName} ${staffDetails.lastName}`,
            assignedStaffEmail: staffDetails.email,
            userId: selectedId,
          };

          this.details.assignedStaffName = `${staffDetails.firstName} ${staffDetails.lastName}`;
          this.details.assignedStaffEmail = staffDetails.email;
          this.details.assignedStaffId = selectedId;
          this.details.assignStaffDetails = reqDetails;
        }
      }
    },
    async assignApproverChanged(newValue) {
      this.details.assignApproverDetails = null;
      this.details.assignedApproverId = null;

      if (this.staffList != null) {
        let staffDetails = this.staffList.filter((v) => v.id == newValue)[0];
        let reqDetails = {
          assignedStaffName: `${staffDetails.firstName} ${staffDetails.lastName}`,
          assignedStaffEmail: staffDetails.email,
          userId: newValue,
        };
        this.details.assignedApproverName = `${staffDetails.firstName} ${staffDetails.lastName}`;
        this.details.assignedApproverEmail = staffDetails.email;
        this.details.assignedApproverId = newValue;
        this.details.assignApproverDetails = reqDetails;
      }
    },
    isAppointmentInPast() {
      if (this.details.appointmentDateTime) {
        const now = new Date(); // Current date and time
        return this.details.appointmentDateTime < now;
      }
      return false;
    },
    // combineAppointmentDateTime() {
    //   const date = new Date(this.details.appointmentDate);
    //   const time = this.details.appointmentTime;

    //   console.log("Date (Before setting time):", date);
    //   console.log("Time:", time);

    //   if (date && time) {
    //     const [hours, minutes] = time.split(":").map(Number); // Ensure time is split correctly and parsed as numbers

    //     // Ensure hours and minutes are valid numbers before setting
    //     if (!isNaN(hours) && !isNaN(minutes)) {
    //       date.setHours(hours);
    //       date.setMinutes(minutes);
    //       date.setSeconds(0); // Optional: Set seconds to 0 if needed
    //       date.setMilliseconds(0); // Optional: Set milliseconds to 0 if needed

    //       console.log("Date (After setting time):", date);
    //       this.details.appointmentDateTime = date;
    //     } else {
    //       console.error("Invalid time format");
    //     }
    //   } else {
    //     console.error("Invalid date or time");
    //   }
    combineAppointmentDateTime() {
      const date = new Date(this.details.appointmentDate);
      const time = this.details.appointmentTime;

      console.log("Date (Before setting time):", date);
      console.log("Time:", time);

      if (date && time) {
        const [hours, minutes] = time.split(":").map(Number);

        if (!isNaN(hours) && !isNaN(minutes)) {
          // Set time
          date.setUTCHours(hours);
          date.setUTCMinutes(minutes);
          date.setUTCSeconds(0);
          date.setUTCMilliseconds(0);

          console.log("Date (After setting time, UTC):", date.toISOString());
          this.details.appointmentDateTime = date.toISOString(); // Ensure UTC time is used
        } else {
          console.error("Invalid time format");
        }
      } else {
        console.error("Invalid date or time");
      }
    },
    async formSubmitted() {
      const isValidMainForm = await this.$refs.AddServiceOrder.validate();
      const isValidSubForm = await this.$refs.AddServiceOrderDetails.validate();
      let allTasksValid = true;

      // Manually validate each task input
      for (let i = 0; i < this.items.length; i++) {
        const taskField = this.$refs[`item-tasks_${i}`];

        if (taskField && taskField[0]) {
          const isValidTask = await taskField[0].validate();
          if (!isValidTask) allTasksValid = false;
        }
      }

      if (!allTasksValid) {
        customErrorMessage(
          "Please fill out all required fields in tasks.",
          "Task Fields"
        );
        return;
      }

      const hasValue = this.items.length > 0 ? true : false;
      const assignStaff = this.details.assignedStaffId != null ? true : false;
      const assignApprover =
        this.details.assignedApproverId != null ? true : false;
      this.combineAppointmentDateTime();

      if (this.isAppointmentInPast()) {
        customErrorMessage(
          "The Date/Time is in the past",
          "Appointment Date/Time"
        );
        return;
      }

      if (!hasValue) {
        customErrorMessage(
          "Please provide at least one template detail",
          "Template Detail"
        );
        return;
      }

      if (!assignStaff) {
        customErrorMessage(
          "Please assign a staff for this service order",
          "Assign staff"
        );
        return;
      }

      if (isValidMainForm && isValidSubForm) {
        let templateDetails = [];
        if (this.items != null && this.items.length > 0) {
          this.items.forEach((detail, index) => {
            var obj = {};
            obj["salesReferenceID"] = "0";
            obj["tasks"] = detail.tasks;
            obj["resources"] = detail.resources;
            obj["tools"] = detail.tools;
            obj["cost"] = detail.price;
            templateDetails.push(obj);
          });
        } else {
          templateDetails = null;
        }

        const mappedProducts = this.invoiceData.items
          .map((item) => {
            console.log("Item: ", item)
            const ProductId = item.value || (item.id && item.id.value);
            const Quantity = item.qty;

            // Return an object only if ProductId exists
            return ProductId ? { ProductId, Quantity } : null;
          })
          .filter((item) => item !== null); // Filter out null values

        let payload = {
          orderTemplateName: this.details.orderName,
          firstName: this.details.firstName,
          lastName: this.details.lastName,
          email: this.details.email,
          ContactNo: this.details.contactNo,
          comments: this.details.comments,
          timeEstimation: this.details.timeEstimation,
          location: this.details.location,
          appointmentDateTime: this.details.appointmentDateTime,
          AssignedApprover: this.details.assignedApproverId,
          AssignedTechnician: this.details.assignedStaffId,
          status: this.details.status,
          price: this.details.price,
          orderTemplateId: this.details.selectedTemplateId,
          orderDetails: templateDetails,
          warehouseId: this.details.warehouseId,
          serviceOrderProducts: mappedProducts,
          assignStaffDetails: [
            {
              assignedStaffName: this.details.assignedStaffName,
              assignedStaffEmail: this.details.assignedStaffEmail,
              userId: this.details.assignedStaffId,
            },
          ],
          assignApproverDetails: {
            assignedStaffName: this.details.assignedApproverName,
            assignedStaffEmail: this.details.assignedApproverEmail,
            userId: this.details.assignedApproverId,
          },
        };

        this.showProcessingDialog(
          "Please wait while the data is being process"
        );
        try {
          const response = await this.postServiceOrderAction({ payload });
          this.hideProcessingDialog();
          this.showSuccess();
          //customSwal("Service Order Added!");
          if (
            response &&
            response.result &&
            response.result.data &&
            response.result.data.referenceNo
          ) {
            this.id = response.result.data.referenceNo;
         //   this.$router.push({ name: "serviceorder-edit", params: { id: this.id }, });
         this.$router.push({ name: "serviceorder-list" });
          } else {
            customError(response);
          }
        } catch (ex) {
  this.hideProcessingDialog();

  const backendMessage =
    ex?.response?.data?.message ||
    ex?.response?.data?.errors ||
    ex?.response?.data ||
    ex?.message ||
    "An unexpected error occurred.";

    console.log("backendMessage", backendMessage);

  customErrorMessage(backendMessage, "Validation Error");
}
      } else {
        customErrorMessage(
          "Please fill out all required fields.",
          "Required Fields"
        );
      }
    },
    error(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: msg ?? " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    errorWarehouse(data) {
      let msg = null;
      // if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: "Selected warehouse does not have any product.",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    getErrorString(data) {
      let msg = null;
      if (data.errors) {
        let errors = data.errors;
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        for (var prop in errors) {
          if (
            Object.prototype.hasOwnProperty.call(errors, prop) &&
            prop !== "request"
          ) {
            msg += "<p>";
            msg += prop.replace("$.", "");
            msg += ": ";
            msg += errors[prop].toString().replace("$.", "");
            msg += "</p>";
          }
        }
        msg += "</div>";
      } else if (data.message) {
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        msg += data.message;
        msg += "</div>";
      }
      return msg;
    },
    AddNew() {
      let dynamicValue = this.defaultItem.length > 0 ? this.defaultItem[0] : [];
      let clonedValue = Object.assign({}, dynamicValue); // Shallow copy
      this.items.push(clonedValue);
      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      this.items.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    removeFromItemForm(index) {
      this.invoiceData.items.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    initTrHeight() {
      this.trSetHeight("form", null);
      this.trSetHeight("tasks", null);
      this.$nextTick(() => {
        this.trSetHeight("form", this.$refs.form.scrollHeight);
        this.trSetHeight("tasks", this.$refs.tasks.scrollHeight);
      });
    },
    async loadProductList() {
      await this.getProductListAction(true).then(() => {
        this.ProductList.map((v, i) => {
          if (v.type !== 4) {
            this.optionsProduct.push({
              qty: 1,
              value: v.id,
              itemTitle: `${v.name}`,
            });
          }
        });
      });
      this.optionsProduct = this.optionsProduct.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.value === item.value)
      );
      this.optionsProduct = fnSortingDropdown(
        this.optionsProduct,
        "asc",
        "itemTitle"
      );
    },
    // add product modal start
    async resetProductModal() {
      this.prodName = "";
      this.prodQty = null;
      this.newProd = false;
      this.$refs.addProductModal.hide();
    },

    async addProduct() {
      let isValid = await this.$refs.addProduct.validate();

      if (isValid) {
        let payload = {
          name: this.prodName,
          initialQuantity: this.prodQty,
        };

        try {
          await this.addProductAction({ product: payload });

          await this.$swal({
            title: "Products!",
            text: "You have successfully added the product!",
            icon: "success",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });

          this.newProd = true;

          this.$refs.addProductModal.hide();
          await this.loadProductList();
          await this.resetProductModal();
        } catch (ex) {
          await this.$swal({
            title: "Error!",
            html: ex.response?.data?.message || "Failed!",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
          await this.resetProductModal();
        }
      }
    },
    // add product modal end
    addNewItemInItemForm() {
      this.invoiceData.items.push(
        JSON.parse(JSON.stringify(this.itemFormBlankItem))
      );

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
        setTimeout(() => {
          this.$refs.form.style.overflow = null;
        }, 350);
      });
    },
    addProductFromModal(selectedProductId) {
      let selectedProduct = this.ProductList.find(
        (product) => product.id === selectedProductId
      );

      if (selectedProduct) {
        this.invoiceData.items.push({
          qty: 1,
          value: selectedProduct.id,
          id: {
            value: selectedProduct.id,
            itemTitle: `${selectedProduct.name}`,
          },
          itemTitle: `${selectedProduct.name}`,
        });

        this.item.id = selectedProduct.id;

        // Hide the modal
        this.$bvModal.hide("modal-barcode");

        this.$nextTick(() => {
          this.trAddHeight(this.$refs.row[0].offsetHeight);
          setTimeout(() => {
            this.$refs.form.style.overflow = null;
          }, 350);
        });
      }
    },
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  created() {
    window.addEventListener("resize", this.initTrHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  beforeMount() {
    this.getProductListAction(true);
  },
  async mounted() {
    try {
      this.showProcessingDialog("Retrieving templates");
      await this.getServiceTemplateListAction().then(() => {
        this.template = [];
        this.servicerequests.map((v, i) =>
          this.template.push({
            value: v.id,
            text: `${v.orderName}`,
          })
        );
      });
      this.hideProcessingDialog();
    } catch (error) {
      console.error("Error fetching service template list:", error);
    }
    try {
      this.showProcessingDialog("Retrieving staff details");

      await this.getStaffForTemplateListAction().then(() => {
  this.allStaffOption = this.staffList.map((option) => {
    return {
      value: option.id,
      text: option.firstName + " " + option.lastName,
    };
  });

  // initial dropdown shows ALL staff
  this.staffOption = [...this.allStaffOption];
});
      this.hideProcessingDialog();
    } catch (error) {
      console.error("Error fetching users list:", error);
    }

    // if (HasPermission(PermissionList.Inventory_Create)){
    //   if (this.warehouse == undefined || this.warehouse.length == 0)
    if (HasPermission(PermissionList.Inventory_Create) && (this.warehouse == undefined || this.warehouse.length == 0))
      await this.getWarehouseListAction();

    this.warehouse.map((v, i) =>
      this.optionsWarehouse.push({
        value: v.id,
        text: `${v.name}`,
      })
    );
    this.optionsWarehouse = fnSortingDropdown(this.optionsWarehouse);

      this.hideProcessingDialog();
      
      if (HasPermission(PermissionList.Inventory_Create)){
      if (this.ProductList == undefined || this.ProductList.length == 0)
        await this.getProductListAction(true);
        await this.loadProductList();
      }

    this.initTrHeight();
  },
  setup() {
    const itemFormBlankItem = {
      item: null,
      value: null,
      cost: 0,
      purchase: 0,
      qty: 1,
      tax: 0,
      profit: 0,
      description: "",
      discountType: 0,
      discount: 0,
    };

    const invoiceData = ref({
      id: 5037,
      client: null,

      // ? Set single Item in form for adding data
      items: [JSON.parse(JSON.stringify(itemFormBlankItem))],

      salesPerson: "",
      note: "It was a pleasure working with you and your team. We hope you will keep us in mind for future freelance projects. Thank You!",
      paymentMethod: null,
    });

    const updateItemForm = (index, val) => {
      const { qty, value } = val;
      invoiceData.value.items[index].qty = val.qty;
      invoiceData.value.items[index].value = val.value;
    };

    return {
      invoiceData,
      updateItemForm,
      itemFormBlankItem,
      HasPermission,
      PermissionList
    };
  },
  computed: {
    ...mapGetters("serviceModule", {
      loading: "loading",
      servicerequests: "servicerequests",
      ServiceTemplateObject: "serviceOne",
      documentDetails: "serviceOrderDocuments",
      staffList: "stafflistrequests",
      file: "file",
    }),
    ...mapGetters("employeeModule", {
      employees: "employees",
      employeeDetails: "employeeid",
    }),
    ...mapGetters("productModule", {
      ProductList: "product",
      loading: "loading",
    }),
    ...mapGetters("warehouseModule", {
      warehouse: "warehouse",
      loading: "loading",
    }),
    templateDDL() {
      if (!this.servicerequests || !Array.isArray(this.servicerequests)) {
        return [];
      }
      return fnSortingDropdown(this.template);
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/quill.scss";
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";
</style>

<style lang="scss">
.form-item-section {
  //  background-color: $product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

#vs7__listbox {
  z-index: -1;
}

.repeater-form {
  // overflow: hidden;
  transition: 0.35s height;
}

.v-select {

  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    // background-color: $theme-dark-body-bg;

    .row .border {
      //    background-color: $theme-dark-card-bg;
    }
  }
}
</style>

<style scoped>
label {
  font-size: 1.714rem !important;
  font-weight: 500;
  margin-bottom: 0;
}

.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}

.v-select .vs__dropdown-menu {
  max-height: 300px;
  /* Ensure the dropdown shows 6 items */
  overflow-y: auto;
  /* Add scrollbar for additional items */
  z-index: 1050;
  /* Higher z-index to prevent it from being hidden by other elements */
}

.b-card-body {
  position: relative;
  /* Ensure dropdown aligns correctly with its parent */
  overflow: visible !important;
  /* Prevent clipping of dropdown */
}

.item-selector-title {
  width: 100%;
  max-width: 300px;
  /* Optional to limit max width on larger screens */
}

@media (max-width: 768px) {
  .item-selector-title {
    width: 100%;
  }
}
</style>
